import { css } from '@emotion/core';
export default {
  name: "122y91a",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;"
};